import { ITutor } from '@wot/typings';
import { SITE_URL, SITE_NAME } from '../../utils/seoConstants';

export interface TutorSchemaProps {
  tutor: ITutor;
}

export const TutorSchema = ({ tutor }: TutorSchemaProps) => {
  if (!tutor) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": tutor.personal?.data?.name || "Tutor",
    "description": tutor.personal?.data?.bio || "",
    "image": tutor.personal?.data?.profilePic || "",
    "url": `${SITE_URL}/find-tutor/${tutor._id}`,
    "knowsAbout": tutor.profession?.data?.categories?.map((c: any) => c.name) || [],
    "speaks": tutor.personal?.data?.languagesSpoken || [],
    "alumniOf": tutor.education?.data?.map((e: any) => e.university) || [],
    "jobTitle": "Online Tutor",
    "worksFor": {
      "@type": "Organization",
      "name": SITE_NAME
    }
  };

  return (
    <script
      key="tutor-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default TutorSchema;
